import { z } from 'zod';
import { hasAtMostDecimalPlaces } from '../promotion-credit/has-at-most-decimal-places.js';
import { SALES_QTY_DECIMALS } from './sales-qty-decimals.js';
const QTY_REQUIRED = 'Enter a quantity to return greater than 0.';
/** A returned quantity: positive, at most 9 decimals; the Create RMA dialog checks it with the same rule. */
export const rmaReturnQtySchema = z
    .number({ error: QTY_REQUIRED })
    .positive({ abort: true, error: QTY_REQUIRED })
    .max(1_000_000_000, 'Enter a quantity of 1,000,000,000 or less.')
    .refine((qty) => hasAtMostDecimalPlaces(qty, SALES_QTY_DECIMALS), {
    error: `Enter a quantity with at most ${SALES_QTY_DECIMALS} decimal places.`,
});
//# sourceMappingURL=rma-return-qty.js.map